<ng-container *ngIf="transformItems.length > 1">
  <ng-container *ngFor="let item of transformItems; trackBy: trackByValue">
    <button
      mat-menu-item
      (click)="setTransform(item.transform)"
      [attr.data-test]="'line-options-menu-transform-' + item.transform"
    >
      <capra-icon
        class="menu-dot-indicator"
        [style.visibility]="item.transform === transform ? 'visible' : 'hidden'"
        icon="icon-dot-indicator"
      >
      </capra-icon>
      {{ item.label }}
    </button>
  </ng-container>
  <mat-divider></mat-divider>
</ng-container>
<button mat-menu-item (click)="setBreakOnNulls()" data-test="line-options-break-on-nulls">
  <capra-icon
    class="menu-dot-indicator"
    [style.visibility]="isBreakOnNulls ? 'visible' : 'hidden'"
    icon="icon-dot-indicator"
  >
  </capra-icon>
  Break on nulls
</button>

<button mat-menu-item (click)="setConnectDashed()" data-test="line-options-dashed-line-for-nulls">
  <capra-icon
    class="menu-dot-indicator"
    [style.visibility]="isConnectDashed ? 'visible' : 'hidden'"
    icon="icon-dot-indicator"
  >
  </capra-icon>
  Dashed line for nulls
</button>
<mat-divider></mat-divider>
<ng-container *ngFor="let interp of interpolationItems">
  <button
    mat-menu-item
    (click)="setInterpolation(interp.type)"
    attr.data-test="line-options-interpolation-{{ interp.type }}"
  >
    <capra-icon
      class="menu-dot-indicator"
      [style.visibility]="interp.type === lineConnectionType ? 'visible' : 'hidden'"
      icon="icon-dot-indicator"
    >
    </capra-icon>
    {{ interp.label }}
  </button>
</ng-container>
